import { invokeScrub } from "../api/ScrubInvokeAPI";
import {UNAUTHORISED_USER} from "../constants/ScrubConstants";


export const initialButtonState = {
    status: "idle",
    enable: true,
    metaDataInvocation: null
}

export const ScrubInvokeReducer = (state = initialButtonState, action) => {
    switch (action.type) {
        case "START_SCRUB":
            const {scrubType, dispatcher} = action.data;
            invokeScrub({scrubType}, dispatcher);
            return {...state, status:"loading" }
        case "SET_STATUS":
            return { ...state, status: action.data }
        case "TOGGLE_BUTTON":
            return { ...state, enable: !state.enable }
        case "UNAUTHORISED_USER":
            return { ...state, status: action.data, metaDataInvocation: {messageStringId: UNAUTHORISED_USER}}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/commons/reducer/ScrubInvokeReducer.js